var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHolderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.953125L9.41436 2.56133L11.9084 2.3855L12.5119 4.8118L14.6329 6.1355L13.695 8.45312L14.6329 10.7708L12.5119 12.0945L11.9084 14.5208L9.41436 14.3449L7.5 15.9531L5.58564 14.3449L3.09161 14.5208L2.48814 12.0945L0.367076 10.7708L1.305 8.45312L0.367076 6.1355L2.48814 4.8118L3.09161 2.3855L5.58564 2.56133L7.5 0.953125Z",
    fill: "#2F80ED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.45312,
    r: 4.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90606 7.4582L5.00627 8.35799L6.16985 9.52156L6.16357 9.52783L7.06336 10.4276L7.06963 10.4213L7.07016 10.4219L7.96995 9.52209L7.96941 9.52156L10.4747 7.01627L9.57492 6.11648L7.06963 8.62178L5.90606 7.4582Z",
    fill: "#2F80ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolderIcon);
export default __webpack_public_path__ + "static/media/holder-icon.98d522f06cbb19a856d2d19297451246.svg";
export { ForwardRef as ReactComponent };